module.exports = __webpack_public_path__ + "static/media/anish_kapoor.505ef500.jpg";